import React from "react";
import "../style/about.css";

const About = () => {
  return (
    <main id="about" className="about-container">
      <h1 className="headings">Sobre mí</h1>
      <p>
        Diseño, creo, actualizo, mantengo páginas y portales web avanzados,
        tanto en el lado del servidor (Back-end) como en el lado del cliente
        (Front-end, UX/UI).
      </p>
      <p>
        Continuamente estoy aprendiendo y adquiriendo nuevas habilidades en
        función a las nuevas tendencias, futuras demandas y nuevas tecnologías
        en el campo del diseño y desarrollo de aplicaciones web en general.
      </p>
      <p style={{ marginBottom: "0.5rem" }}>
        Soy muy apasionado con el trabajo que realizo, ofreciendo en cada
        proyecto una total atención, dedicación, personalización y calidad para
        el cliente.
      </p>
      {/* <h3 className="conocimientos">
          HTML5 - CSS3 - JAVASCRIPT - REACT.JS - MONGODB - NODE.JS - PHP8 -
          MYSQL - GIT/GITHUB - DISENO ADAPTABLE - BOOTSTRAP 4 - ADOBE PHOTOSHOP
          CC - ADOBE ILLUSTRADOR CC - ADOBE AFTER EFFECTS
        </h3> */}
    </main>
  );
};

export default About;
